import { Button, IColumn, TableConfig } from "ngx-eo-web-components";
import { isObservable, Observable } from "rxjs";

export interface ITableConfigBuilder<T> {
  setTableData(data: Observable<T[]> | T[]): ITableConfigBuilder<T>;
  getTableConfig(): TableConfig<T>;
  setColumns(columns: IColumn<T>[]): ITableConfigBuilder<T>;
  addColumn(column: IColumn<T>): ITableConfigBuilder<T>;
  setTitle(Title: string): ITableConfigBuilder<T>;
  setLineNumbers(LineNumbers: boolean): ITableConfigBuilder<T>;
  setIconButton(IconButton: Button<T>[]): ITableConfigBuilder<T>;
  addFunction(key: string, func: (data?: any) => any): ITableConfigBuilder<T>;
  getFunction(key: string, data?: any): ((data?: any) => any) | undefined;
}

export class TableConfigBuilder<T> implements ITableConfigBuilder<T> {

  private config: TableConfig<T>;
  private functions: { [key: string]: (data?: any) => any } = {};

  constructor() {
    this.config = {
      Title: '',
      Columns: [],
    }
  }

  setTableData(data: Observable<T[]> | T[]) {
    if (isObservable(data)) {
      this.config.BehaviorData = data;
      //console.log('isObservable');
    } else {
      this.config.Data = data;
      //console.log('isNotObservable');
    }
    //console.log('this.config',this.config);

    return this;
  }

  getTableConfig(): TableConfig<T> {
    return this.config;
  }

  setColumns(columns: IColumn<T>[]) {
    this.config.Columns = columns;
    return this;
  }

  addColumn(column: IColumn<T>) {
    this.config.Columns = [...this.config.Columns, column];
    return this;
  }

  setTitle(Title: string) {
    this.config.Title = Title;
    return this;
  }

  setLineNumbers(LineNumbers: boolean) {
    this.config.LineNumbers = LineNumbers;
    return this;
  }

  setIconButton(IconButton: Button<T>[]) {
    this.config.IconButton = IconButton;
    return this;
  }

  addFunction(key: string, func: (data?: any) => any) {
    this.functions[key] = func;
    return this;
  }

  getFunction(key: string, data?: any): ((data?: any) => any) | undefined {
    if(data){
      return this.functions[key](data);
    }
    return this.functions[key];
  }
}
